import { PopupNames } from 'core';
import { usePopupData } from './usePopupData';

export const useGetConfirmPopupData = () => {
  const data = usePopupData(PopupNames.confirmPopup);

  return data;
};
